module.exports = __webpack_public_path__ + "assets/images/right-icon.deee41c50b3f72486e779c476885695e.svg";